import { EN, BG } from "translation";

export const DEFAULT_LOCALE = EN;
export const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.mydailybudgetapp";
